// @ts-nocheck
/* ==========================================================================
   Kult-Rösterei — Kaffeezubereitung
   Brührechner + Sync-System zwischen Hero-Nav, Rechner, Step-Tabs
   und Sorten-Matching. Nutzt zentrales assets/kult-motion.js für Reveals.
   ========================================================================== */
(function () {

  if (window.__kultKzInit) return;
  window.__kultKzInit = true;

  var STRENGTH_KEYS = ['mild', 'mittel', 'stark'];

  var METHOD_DATA = {
    handfilter: {
      label: 'Handfilter',
      ratios: [18.0, 16.67, 15.0],
      ratioNotes: [
        'Mildes Verhältnis: mehr Wasser pro Gramm Kaffee für einen sanften, klaren Geschmack.',
        'Ausgewogenes Standard-Verhältnis für die meisten Röstungen.',
        'Kräftiges Verhältnis: weniger Wasser für mehr Intensität.'
      ],
      grind: 'Mittel-fein',
      temp: '92–94',
      time: '2:30–3:30 Min.',
      timeBig: '3:30–4:30 Min.', // ab 600 ml (größere Kanne, längere Kontaktzeit; SCA 2–4 Min. je Tasse)
      timeLabel: 'Brühzeit',
      unit: 'ml',
      min: 150,
      max: 1000, // Handfilter: größere Mengen sind kein Handfilter mehr (Cowork 24.10.)
      step: 10,
      default: 300,
      zubehoerShow: true,
      zubehoerText: 'Du brauchst: Handfilter, Papierfilter, Kaffeewaage, Gooseneck-Kessel.',
      showFlowHint: false
    },
    frenchpress: {
      label: 'French Press',
      ratios: [16.67, 15.38, 14.28],
      ratioNotes: [
        'Mild: leichteres, klareres Ergebnis.',
        'Ausgewogenes Standard-Verhältnis.',
        'Kräftig: volles, intensives Mundgefühl.'
      ],
      grind: 'Grob',
      temp: '94–96',
      time: '4:00 Min.',
      timeLabel: 'Ziehzeit',
      unit: 'ml',
      min: 200,
      max: 1500,
      step: 10,
      default: 500,
      zubehoerShow: true,
      zubehoerText: 'Du brauchst: French Press, Kaffeewaage, grobes Mahlwerk.',
      showFlowHint: false
    },
    siebtraeger: {
      label: 'Siebträger',
      ratios: [2.2, 2.0, 1.8],
      ratioNotes: [
        'Mild: längerer, sanfterer Extrakt.',
        'Ausgewogenes Espresso-Standardverhältnis.',
        'Kräftig: konzentrierter, intensiver Shot.'
      ],
      grind: 'Sehr fein',
      temp: '90–92',
      time: '25–30 Sek.',
      timeLabel: 'Extraktionszeit',
      unit: 'g Ausgabe',
      shots: {
        single: { min: 15, max: 25, step: 1, default: 18 },
        double: { min: 30, max: 50, step: 1, default: 36 }
      },
      zubehoerShow: false,
      zubehoerText: '',
      showFlowHint: true
    },
    vollautomat: {
      label: 'Vollautomat',
      ratios: [12.0, 10.0, 8.0],
      ratioNotes: [
        'Mild: mehr Wasser, sanfterer Kaffee.',
        'Werkseinstellung der meisten Vollautomaten.',
        'Kräftig: weniger Wasser, intensiverer Geschmack.'
      ],
      grind: 'Fein bis mittel-fein',
      temp: '90–92 (Werkseinstellung)',
      time: '25–30 Sek.',
      timeLabel: 'Ausgabezeit',
      unit: 'ml',
      min: 100,
      max: 400,
      step: 10,
      default: 120,
      zubehoerShow: false,
      zubehoerText: '',
      showFlowHint: true
    },
    herdkanne: {
      label: 'Herdkanne',
      /* Das Sieb bestimmt die Menge (immer randvoll, nicht andrücken; Wasser bis unter das Ventil): rund 1:10, unabhängig
         von der Stärke. Stärker wird er über den Mahlgrad (Later-Liste 22.10. Nr. 13). */
      ratios: [10.0, 10.0, 10.0],
      ratioNotes: [
        'Mild: Sieb randvoll, Mahlgrad eine Stufe gröber.',
        'Sieb randvoll, nicht andrücken. Wasser bis knapp unter das Ventil.',
        'Kräftig: Sieb randvoll, Mahlgrad eine Stufe feiner, aber gröber als für Espresso.'
      ],
      grind: 'Mittel-fein',
      temp: '90 (vorgeheizt)',
      time: 'bis es zu gurgeln beginnt, dann sofort vom Herd',
      timeLabel: 'Kochzeit',
      unit: 'ml',
      min: 150,
      max: 450,
      step: 150,
      default: 150,
      zubehoerShow: false,
      zubehoerText: '',
      showFlowHint: false
    }
  };

  var FLOW_HINTS = {
    siebtraeger: 'Läuft der Shot zu schnell oder zu langsam? Mahlgrad feiner (langsamer) oder gröber (schneller) einstellen.',
    vollautomat: 'Läuft die Ausgabe zu schnell oder zu langsam? Über das Mahlwerk am Gerät nachjustieren.'
  };

  var ANCHOR_LABELS = {
    handfilter: 'Handfilter-Guide',
    frenchpress: 'French-Press-Guide',
    siebtraeger: 'Siebträger-Guide',
    vollautomat: 'Vollautomat-Guide',
    herdkanne: 'Herdkannen-Guide'
  };

  /* Sensorik (02.10.2026): Röstgrad 1–3 (drei Bohnen wie auf dem Etikett), Säure/Intensität 1–5,
     Dezimalwerte mit halben Stufen → halb gefülltes Icon (.kult-kz-card__half, CSS in kult-kaffeezubereitung.css) */
  var ATTR_META = {
    roast: { cls: 'attr-bean', max: 3, label: 'Röstgrad' },
    acidity: { cls: 'attr-drop', max: 5, label: 'Säure' },
    intensity: { cls: 'attr-dot', max: 5, label: 'Intensität' }
  };

  function attrNum(value) {
    var n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  }

  function attrLabel(kind, value) {
    var meta = ATTR_META[kind] || ATTR_META.intensity;
    var r = Math.max(0, Math.min(meta.max, Math.round(attrNum(value) * 10) / 10));
    return meta.label + ' ' + String(r).replace('.', ',') + ' von ' + meta.max;
  }

  function attrIconsHtml(kind, value) {
    var meta = ATTR_META[kind] || ATTR_META.intensity;
    var cls = meta.cls;
    var halves = Math.round(attrNum(value) * 2);
    var html = '';
    for (var i = 1; i <= meta.max; i++) {
      if (halves >= i * 2) html += '<span class="attr-dot-wrap ' + cls + ' is-filled"></span>';
      else if (halves === i * 2 - 1) html += '<span class="kult-kz-card__half"><span class="attr-dot-wrap ' + cls + '"></span><span class="attr-dot-wrap ' + cls + ' is-filled"></span></span>';
      else html += '<span class="attr-dot-wrap ' + cls + '"></span>';
    }
    return html;
  }

  document.querySelectorAll('.kult-kz-calc[data-default-method]').forEach(function (calcRoot) {
    var currentMethod = calcRoot.getAttribute('data-default-method') || 'handfilter';
    var currentStrength = 1; // 0 mild, 1 mittel, 2 stark
    var currentShot = 'single';

    var methodButtons = calcRoot.querySelectorAll('.kult-kz-calc__method');
    var shotButtons = calcRoot.querySelectorAll('.kult-kz-calc__shot-btn');
    var shotToggle = calcRoot.querySelector('.kult-kz-calc__shot-toggle');
    var slider = calcRoot.querySelector('.kult-kz-calc__slider');
    var strengthSlider = calcRoot.querySelector('.kult-kz-calc__strength-slider');
    var statCoffee = calcRoot.querySelector('[data-stat="coffee"]');
    var statGrind = calcRoot.querySelector('[data-stat="grind"]');
    var statTemp = calcRoot.querySelector('[data-stat="temp"]');
    var statTime = calcRoot.querySelector('[data-stat="time"]');
    var statTimeLabel = calcRoot.querySelector('[data-stat="time-label"]');
    var sliderValueEl = calcRoot.querySelector('[data-slider-value]');
    var ratioNoteEl = calcRoot.querySelector('.kult-kz-calc__ratio-note');
    var flowHintEl = calcRoot.querySelector('.kult-kz-calc__flow-hint');
    var zubehoerHintEl = calcRoot.querySelector('.kult-kz-calc__zubehoer-hint');
    var anchorEl = calcRoot.querySelector('.kult-kz-calc__anchor a');

    function currentUnit() {
      return METHOD_DATA[currentMethod].unit;
    }

    function updateSliderBounds() {
      var m = METHOD_DATA[currentMethod];
      if (!slider) return;
      if (currentMethod === 'siebtraeger') {
        var s = m.shots[currentShot];
        slider.min = s.min;
        slider.max = s.max;
        slider.step = s.step;
        slider.value = s.default;
        if (shotToggle) shotToggle.style.display = '';
      } else {
        slider.min = m.min;
        slider.max = m.max;
        slider.step = m.step;
        slider.value = m.default;
        if (shotToggle) shotToggle.style.display = 'none';
      }
    }

    function updateCalc() {
      var m = METHOD_DATA[currentMethod];
      var val = slider ? parseFloat(slider.value) : m.default;
      var ratio = m.ratios[currentStrength];
      var coffeeGrams = val / ratio;

      /* Herdkanne: Kannengröße statt freier ml-Menge (50 ml je Tasse) */
      var valText = val + ' ' + currentUnit() + (currentMethod === 'herdkanne' ? ' · ' + Math.round(val / 50) + '-Tassen-Kanne' : '');
      if (sliderValueEl) sliderValueEl.textContent = valText;
      /* Ganze Gramm für alle Zubereitungen (Later-Liste Nr. 13, Cowork 24.10.: auch Siebträger) */
      if (statCoffee) statCoffee.textContent = String(Math.round(coffeeGrams)) + ' g';
      if (statGrind) statGrind.textContent = m.grind;
      if (statTemp) { var tParts = String(m.temp).split(' ('); statTemp.textContent = tParts[0] + ' °C' + (tParts[1] ? ' (' + tParts[1] : ''); }
      if (statTime) statTime.textContent = m.timeBig && val >= 600 ? m.timeBig : m.time;
      if (statTimeLabel) statTimeLabel.textContent = m.timeLabel;
      if (ratioNoteEl) ratioNoteEl.textContent = m.ratioNotes[currentStrength];

      if (flowHintEl) {
        if (m.showFlowHint && FLOW_HINTS[currentMethod]) {
          flowHintEl.textContent = FLOW_HINTS[currentMethod];
          flowHintEl.style.display = '';
        } else {
          flowHintEl.style.display = 'none';
        }
      }

      if (zubehoerHintEl) {
        if (m.zubehoerShow) {
          zubehoerHintEl.textContent = m.zubehoerText;
          zubehoerHintEl.style.display = '';
        } else {
          zubehoerHintEl.style.display = 'none';
        }
      }

      if (anchorEl) {
        anchorEl.textContent = 'Zum ' + (ANCHOR_LABELS[currentMethod] || 'Guide') + ' →';
        anchorEl.setAttribute('data-tab', currentMethod);
      }
    }

    function setActiveMethodButton() {
      methodButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-method') === currentMethod);
      });
    }

    methodButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var method = btn.getAttribute('data-method');
        calcRoot.__kzApi.setMethod(method);
        setGlobalBrewMethod(method, 'calc');
      });
    });

    shotButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        currentShot = btn.getAttribute('data-shot');
        shotButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        updateSliderBounds();
        updateCalc();
      });
    });

    if (slider) {
      slider.addEventListener('input', updateCalc);
    }

    if (strengthSlider) {
      strengthSlider.addEventListener('input', function () {
        currentStrength = parseInt(strengthSlider.value, 10);
        updateCalc();
      });
    }

    calcRoot.__kzApi = {
      setMethod: function (method) {
        if (!METHOD_DATA[method]) return;
        currentMethod = method;
        setActiveMethodButton();
        updateSliderBounds();
        updateCalc();
      }
    };

    setActiveMethodButton();
    updateSliderBounds();
    updateCalc();
  });

  /* ---------------- Step-Tabs ---------------- */
  document.querySelectorAll('.kult-kz-steps').forEach(function (stepsRoot) {
    var tabs = stepsRoot.querySelectorAll('.kult-kz-tab');
    var panels = stepsRoot.querySelectorAll('.kult-kz-panel');

    function openTab(method) {
      /* Methoden ohne eigenen Guide (z. B. Filtermaschine im Sorten-Matching) lassen den aktiven Tab stehen */
      var hasTab = Array.prototype.some.call(tabs, function (tab) { return tab.getAttribute('data-tab') === method; });
      if (!hasTab) return;
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-tab') === method;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.id === 'panel-' + method);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var method = tab.getAttribute('data-tab');
        openTab(method);
        setGlobalBrewMethod(method, 'tabs');
      });
    });

    stepsRoot.__kzApi = { openTab: openTab };

    /* Kennzahlen-Zeile je Guide (07.10.2026): dieselben Werte wie der Brührechner (METHOD_DATA), keine zweite Datenquelle */
    stepsRoot.querySelectorAll('[data-kz-facts]').forEach(function (dl) {
      var d = METHOD_DATA[dl.getAttribute('data-kz-facts')];
      if (!d) return;
      var rows = [['Mahlgrad', d.grind], ['Wasser', String(d.temp).replace(/^([\d–-]+)/, '$1 °C')], [d.timeLabel, d.time]];
      dl.innerHTML = rows.map(function (r) {
        return '<div class="kult-kz-panel__fact"><dt>' + r[0] + '</dt><dd>' + r[1] + '</dd></div>';
      }).join('');
      dl.hidden = false;
    });

    var defaultHolder = stepsRoot.querySelector('[data-default-method]');
    var initial = (defaultHolder && defaultHolder.getAttribute('data-default-method')) || 'handfilter';
    openTab(initial);
  });

  /* ---------------- Sorten-Matching ----------------
     Seit 05.10.2026 rendert Liquid alle Kaffees als Standard-Produktkarten (snippets/kult-product-card.liquid) in
     .kult-kz-match__item mit data-methods="handfilter filtermaschine …" (aus den Tags zubereitung_*). Das Skript blendet
     nur noch ein und aus, die Karten selbst sind dieselben wie in der Kaffee-Übersicht. */
  document.querySelectorAll('.kult-kz-match__inner').forEach(function (matchRoot) {
    var filters = matchRoot.querySelectorAll('.kult-kz-match__filter');
    var grid = matchRoot.querySelector('.kult-kz-match__grid');
    var items = grid ? Array.prototype.slice.call(grid.querySelectorAll('.kult-kz-match__item')) : [];
    var emptyEl = matchRoot.querySelector('[data-match-empty]');
    var currentMatchMethod = matchRoot.getAttribute('data-default-method') || 'handfilter';

    var allLink = matchRoot.querySelector('[data-kz-all]');
    var mqMobile = window.matchMedia('(max-width: 599px)');

    /* Seit 07.10.2026: nur die ersten N passenden Sorten (Settings limit_desktop/limit_mobile), darunter der Link
       „Alle [anzahl] Sorten für [methode]“; der Link trägt ?zubereitung=<methode>, damit filtert die Kaffee-Übersicht vor. */
    function renderMatchGrid(method) {
      var limit = parseInt(matchRoot.getAttribute(mqMobile.matches ? 'data-limit-mobile' : 'data-limit-desktop'), 10) || 999;
      var matched = 0;
      items.forEach(function (item) {
        var on = (' ' + (item.getAttribute('data-methods') || '') + ' ').indexOf(' ' + method + ' ') > -1;
        if (on) matched++;
        item.hidden = !on || matched > limit;
      });
      if (emptyEl) emptyEl.hidden = matched > 0;
      var tpl = allLink && allLink.getAttribute('data-label-method');
      var btn = matchRoot.querySelector('.kult-kz-match__filter[data-method="' + method + '"]');
      if (tpl && btn && matched > 0) {
        allLink.textContent = tpl.replace('[anzahl]', matched).replace('[methode]', btn.textContent.trim());
        /* Kaffee-Übersicht filtert nur noch per URL-Parameter vor (12.10.2026, U22), nicht mehr aus localStorage */
        allLink.setAttribute('href', (allLink.getAttribute('href') || '').split('?')[0] + '?zubereitung=' + encodeURIComponent(method));
      }
    }
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', function () { renderMatchGrid(currentMatchMethod); });

    function setActiveFilter() {
      filters.forEach(function (btn) {
        var on = btn.getAttribute('data-method') === currentMatchMethod;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function setMatchMethod(method, animate) {
      if (!method) return;
      currentMatchMethod = method;
      setActiveFilter();
      if (animate && grid) {
        grid.classList.add('is-fading');
        setTimeout(function () {
          renderMatchGrid(method);
          grid.classList.remove('is-fading');
        }, 220);
      } else {
        renderMatchGrid(method);
      }
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var method = btn.getAttribute('data-method');
        setGlobalBrewMethod(method, 'match');
      });
    });

    matchRoot.__kzApi = { setMethod: setMatchMethod };

    setActiveFilter();
    renderMatchGrid(currentMatchMethod);
  });

  /* ---------------- Zentrale Sync-Funktion ---------------- */
  function setGlobalBrewMethod(method, triggerOrigin) {
    document.querySelectorAll('.kult-kz-calc[data-default-method]').forEach(function (calcRoot) {
      if (triggerOrigin === 'calc') return;
      if (calcRoot.__kzApi) calcRoot.__kzApi.setMethod(method);
    });

    document.querySelectorAll('.kult-kz-steps').forEach(function (stepsRoot) {
      if (triggerOrigin === 'tabs') return;
      if (stepsRoot.__kzApi) stepsRoot.__kzApi.openTab(method);
    });

    document.querySelectorAll('.kult-kz-match__inner').forEach(function (matchRoot) {
      if (matchRoot.__kzApi) matchRoot.__kzApi.setMethod(method, true);
    });

    markActiveNav(method);
    if (triggerOrigin !== 'init') {
      try { window.localStorage.setItem('kult:method', method); } catch (e) { /* Storage blockiert */ }
      document.dispatchEvent(new CustomEvent('kult:method:changed', { detail: { method: method } }));
    }
  }

  /* Aktiver Zustand für Hero-Pills und schwebende Methodenleiste (07.10.2026) */
  function markActiveNav(method) {
    document.querySelectorAll('.kult-kz-nav__pill[data-tab]').forEach(function (pill) {
      var on = pill.getAttribute('data-tab') === method;
      pill.classList.toggle('is-active', on);
      if (on) pill.setAttribute('aria-current', 'true'); else pill.removeAttribute('aria-current');
    });
    document.querySelectorAll('.kult-kz-dock__pill').forEach(function (pill) {
      var on = pill.getAttribute('data-tab') === method;
      pill.classList.toggle('is-active', on);
      pill.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    /* In waagerecht scrollbaren Leisten (mobil) die aktive Pill sichtbar halten */
    document.querySelectorAll('.kult-kz-dock__inner, .kult-kz-nav, .kult-kz-tabs').forEach(function (bar) {
      var active = bar.querySelector('.is-active');
      if (!active || bar.scrollWidth <= bar.clientWidth) return;
      var a = active.getBoundingClientRect(), b = bar.getBoundingClientRect();
      bar.scrollLeft += (a.left - b.left) - (b.width - a.width) / 2;
    });
  }

  window.kultKzSetBrewMethod = setGlobalBrewMethod;

  /* ---------------- Hero-Anker & Calc-Anker Klicks ---------------- */
  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-tab]');
    if (!target) return;
    if (target.classList.contains('kult-kz-tab') || target.classList.contains('kult-kz-calc__method') || target.classList.contains('kult-kz-match__filter')) {
      return; // already handled by dedicated listeners above
    }
    var method = target.getAttribute('data-tab');
    if (!method) return;
    e.preventDefault();
    setGlobalBrewMethod(method, 'nav');
    /* Links springen zu ihrem Anker (Hero → Rechner, Rechner → Guide, Guide → Sorten); Buttons der Leiste wechseln nur */
    var href = target.tagName === 'A' ? target.getAttribute('href') || '' : '';
    var dest = href.charAt(0) === '#' && href.length > 1 ? document.getElementById(href.slice(1)) : null;
    if (dest) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      dest.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
  });

  /* ---------------- Schwebende Methodenleiste ---------------- */
  var dock = document.querySelector('[data-kz-dock]');
  var heroNav = document.querySelector('[data-kz-hero-nav]');
  if (dock && heroNav && 'IntersectionObserver' in window) {
    var heroVisible = true;
    var endVisible = false;
    var endEl = document.querySelector('.kult-kz-cta') || document.querySelector('footer');
    var syncDock = function () {
      var show = !heroVisible && !endVisible;
      dock.classList.toggle('is-visible', show);
      dock.setAttribute('aria-hidden', show ? 'false' : 'true');
      dock.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    };
    new IntersectionObserver(function (entries) {
      heroVisible = entries[0].isIntersecting;
      syncDock();
    }).observe(heroNav);
    if (endEl) {
      new IntersectionObserver(function (entries) {
        endVisible = entries[0].isIntersecting;
        syncDock();
      }).observe(endEl);
    }
  }

  /* Startzustand: gemerkte Zubereitung (localStorage 'kult:method'), sonst Standard des Guides */
  var remembered = '';
  try { remembered = window.localStorage.getItem('kult:method') || ''; } catch (e) { remembered = ''; }
  if (remembered && document.getElementById('panel-' + remembered)) {
    setGlobalBrewMethod(remembered, 'init');
  } else {
    var activeTab = document.querySelector('.kult-kz-tab.is-active');
    if (activeTab) markActiveNav(activeTab.getAttribute('data-tab'));
  }
})();
